export const decode = (text) => text.replace(/!%/g, "<").replace(/%!/g, ">")

export const encode = (text) => text.replace(/<b(.*?)>/g, "!%b$1%!")
  .replace(/<\/b>/g, "!%/b%!")
